import { render, staticRenderFns } from "./PayBoxOpen.vue?vue&type=template&id=2ce13b49&scoped=true&"
import script from "./PayBoxOpen.vue?vue&type=script&lang=js&"
export * from "./PayBoxOpen.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxOpen.vue?vue&type=style&index=0&id=2ce13b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce13b49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce13b49')) {
      api.createRecord('2ce13b49', component.options)
    } else {
      api.reload('2ce13b49', component.options)
    }
    module.hot.accept("./PayBoxOpen.vue?vue&type=template&id=2ce13b49&scoped=true&", function () {
      api.rerender('2ce13b49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-open/PayBoxOpen.vue"
export default component.exports